export default __webpack_public_path__ + "static/media/TassoLoadingLogo.0c89e08e.gif";